module.exports = __webpack_public_path__ + "ov_5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/contact/ov/ov_5.jpg
// module id = 876
// module chunks = 0